// extracted by mini-css-extract-plugin
module.exports = {"titleContent":"TitlePlaceholder_titleContent__1CFWH","removeFocus":"TitlePlaceholder_removeFocus__2dCgC"};